import React from 'react';
import { Timeline } from 'antd';

export default function KoTimeLine(props) {
  
  return (
    <Timeline {...props}/>
  );
}
